import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { SelectModule } from "primeng/select";
import { DatePickerComponent } from "./date-picker.component";
import { NgxDaterangepickerMd } from "ngx-daterangepicker-material";
import { DatePickerModule as PrimeNgDatePickerModule } from "primeng/datepicker";
import { ButtonModule } from "primeng/button";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    PrimeNgDatePickerModule,
    SelectModule,
    NgxDaterangepickerMd.forRoot(),
    DatePickerComponent,
  ],
  exports: [CommonModule, FormsModule, DatePickerComponent],
})
export class DatePickerModule {}
